module.exports = __webpack_public_path__ + "img/twitter.3ce468ae.svg";